export default [
    {
        header: 'Main pages',
        visibleFor: ['all'],
    },
    {
        title: 'Dashboard',
        icon: 'HomeIcon',
        tagVariant: 'light-warning',
        route: 'home',
        visibleFor: ['all'],
    },
]
